import React from "react";
import styled from "styled-components";

const CallButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    appearance: none;
    color: ${({type}) => type !== 'active' ? '#ffffff' : '#000000'};
    height: 60px;
    width: ${({round}) => round ? '60px' : 'auto'};
    border-radius: 30px;
    padding: ${({round}) => round ? '0.5em' : '0.5em 2.5em'};
    font-size: 16px;
    font-weight: 600;
    background: ${({type = ''}) => {
        switch (type) {
            case 'primary':
                return '#5562c0';
            case 'active':
                return '#ffffff';
            case 'danger':
                return '#ED6D5F';
            case 'hollow':
            default:
                return 'transparent';
        }
    }};
    outline: none;
    border: ${({type = ''}) => {
        switch (type) {
            case 'primary':
            case 'danger':
                return 'none';
            default:
                return '1px solid #ffffff';
        }
    }};

    img {
        height: 75%;
    }
`

export default CallButton
